import { loginReq, rememberLoginReq, clearRememberReq   , sendOtpReq,changePasswordReq ,verifyOtpReq , logoutReq } from "../Api/index";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setActionsControleR, setCaptchR } from "../../../General/Store/GeneralSlice";
import { customApi } from "../../../CustomHoock/CustomApi";
import decClims from "../../../utils/decClaims";
import axios from "axios";
import { baseApiUrl } from "../../../env";


/*====================== shared success handler ==============================*/
const handleAuthSuccess = (data, dispatch, navigate, handleSuccess) => {
  if (!data?.data?.data?.needCaptcha) {
    const claims = data?.data?.data?.claims || [];
    const collectionId = data?.data?.data?.collectionId;
    const secureClaims = data?.data?.data?.secureClaims;
    const refreshToken =  data?.data?.data?.refreshToken;
    const resultClaime = decClims(secureClaims);
    Cookies.set("collectionId", collectionId, { expires: 7 });
    // localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("claims", JSON.stringify(resultClaime));

    const userInfo = {
      token: data?.data?.data?.token,
      userId: data?.data?.data?.id,
      personId: data?.data?.data?.personId,
      userRole: data?.data?.data?.userRoles,
      userLogin: {
        firstName: data?.data?.data?.firstName,
        lastName: data?.data?.data?.lastName,
      },
      userImageUr: data?.data?.data?.userImageUrl,
    };

    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    navigate("/dashboard/overview", { replace: true });

    const actionDetails = {};
    if (claims.length > 0) {
      claims.forEach((element) => {
        actionDetails[element.controllerName] = element.actionDetails;
      });
      dispatch(setActionsControleR(actionDetails));
    }

    handleSuccess?.("ورود موفق");
  } else {
    dispatch(setCaptchR(true));
  }
};

/*====================== Login ==============================*/
const useLoginReq = (handleSuccess, handleFailed, onMustChange) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useMutation(
    (data) => loginReq(data),
    {
      onSuccess: (data) => {
        const responseData = data?.data?.data;
       if (responseData?.mustChangePassword) {
          const collectionId = responseData?.collectionId;
          onMustChange?.(collectionId);
          return;
        }
       

         handleAuthSuccess(data, dispatch, navigate, handleSuccess);

       
      },
      onError: (error) => {
        const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;

        if (errorList) {
          errorList.forEach((errorListItem) => {
            errorListItem.resourceKeys.forEach((errorText) => handleFailed?.(errorText));
          });
        } else {
          handleFailed?.("خطایی رخ داده است");
        }
      },
    }
  );
};

/*====================== Remember Login ==============================*/
const useRememberLoginReq = (handleSuccess, handleFailed, onMustChange) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useMutation(
    () => rememberLoginReq(),
    {
      onSuccess: (data) => {
      
        const responseData = data?.data?.data;
      
       if (responseData?.mustChangePassword) {
       
          const collectionId = responseData?.collectionId;
          onMustChange?.(collectionId);
          return;
        }
       
        handleAuthSuccess(data, dispatch, navigate, handleSuccess);
      },
      onError: (error) => {
      
        const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
        if (errorList) {
          errorList.forEach((errorListItem) => {
            const element = errorListItem.resourceKeys;
            element.forEach((errorText) => handleFailed?.(errorText));
          });
          
        } else {
          handleFailed?.("خطایی رخ داده است");
        }
      },
    }
  );
};

/*================================ Log out ==============================*/
const useGetLogout = () => {
  const navigate = useNavigate();

  return useMutation(
    () => {
     
      const isRemember = localStorage.getItem("rememberMe") === "true";
   
      return logoutReq(isRemember);
    },
    {
      onSuccess: () => {
        localStorage.removeItem("claims");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("refreshToken");

        const isRemember = localStorage.getItem("rememberMe") === "true";

        if (!isRemember) {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("rememberedUsername");
         // localStorage.removeItem("hasRefreshToken");
        }

        navigate("/");
      },
    }
  );
};

const getLoginPage = async (id) => {
  const response = await axios.get(`${baseApiUrl}/api/v1/LoginPage/GetLoginPage`, {
    params: { id },
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
    withCredentials: true,
  });
  return response.data?.data;
};

const useClearRememberReq = (handleSuccess, handleFailed) =>
  useMutation(() => clearRememberReq(), {
    onSuccess: () => handleSuccess?.("ورود خودکار غیرفعال شد"),
    onError: (err) =>
      handleFailed?.(err?.response?.data?.message || "خطا در غیر فعال کردن ورود خودکار"),
  });


const useSendOtpReq = (handleSuccess, handleFailed) =>
  useMutation((data) => sendOtpReq(data), {
    onSuccess: (response) => {
      // بررسی موفق بودن عملیات بر اساس مقدار boolean برگشتی
      if (response?.data?.data === true) {
        handleSuccess?.();
      } else {
        handleFailed?.("خطا در ارسال پیامک، لطفا مجددا تلاش کنید");
      }
    },
    onError: (error) => {
      const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
      if (errorList?.length) {
        errorList.forEach((item) =>
          item.resourceKeys.forEach((text) => handleFailed?.(text))
        );
      } else {
        handleFailed?.("خطایی در ارتباط با سرور رخ داده است");
      }
    },
  });
  const useChangePasswordReq = (handleSuccess, handleFailed) =>
  useMutation((data) => changePasswordReq(data), {
    onSuccess: (response) => handleSuccess?.(response.data),
    onError: (error) => {
      const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
      if (errorList) {
        errorList.forEach((item) =>
          item.resourceKeys.forEach((text) => handleFailed?.(text))
        );
      } else {
        handleFailed?.("خطایی رخ داده است");
      }
    },
  });

  const useVerifyOtpReq = (handleSuccess, handleFailed) =>
  useMutation((data) => verifyOtpReq(data), {
    onSuccess: (response) => {
      
      if (response.data?.data === true) {
       
        handleSuccess?.();
      } else {
        handleFailed?.("کد تایید صحیح نیست");
      }
    },
    onError: (error) => {
    
      const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
      if (errorList) {
        errorList.forEach((item) =>
          item.resourceKeys.forEach((text) => handleFailed?.(text))
        );
      } else {
        handleFailed?.("کد تایید صحیح نیست");
      }
    },
  });

export { useLoginReq, useRememberLoginReq, useGetLogout, getLoginPage, useClearRememberReq , useChangePasswordReq , useSendOtpReq ,useVerifyOtpReq };
